var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":"failed"}}),_vm._v(" "),_c('div',{staticClass:"media-body space-children"},[_c('bold-text',{attrs:{"message":_vm.$options.message}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }